<div mat-dialog-content fxLayout="column" fxLayoutAlign="start">
    <div class="related-posting-container">
        <mat-icon class="close-dialog" (click)="dialogRef.close(false)">close</mat-icon>
        <div class="layer"></div>
        <div class="posting-image" *ngIf="relatedPostings[index].image" [style.background-image]="'url(' + relatedPostings[index].image.url + ')'"></div>
        <div class="posting-title">
            <mat-chip-set tabIndex="-1" *ngIf="relatedPostings[index].postingType.displayNameKeySingular">
                <mat-chip [disableRipple]="true">{{ relatedPostings[index].postingType.displayNameKeySingular | translate }}</mat-chip>
            </mat-chip-set>
            <h2 tabIndex="0">{{ relatedPostings[index].translation ? relatedPostings[index].translation.title : relatedPostings[index].translations[0].title }}</h2>
        </div>
        <div class="swiper-button-prev-container" *ngIf="!isFirst" (click)="prevPost()">
            <div class="swiper-button-prev"></div>
        </div>
        <div class="swiper-button-next-container" *ngIf="!isLast" (click)="nextPost()">
            <div class="swiper-button-next"></div>
        </div>
    </div>
    <div class="posting-content p-40">
        <p
            [innerHTML]="
                relatedPostings[index].translation ? (relatedPostings[index].translation.description | safeHtml) : (relatedPostings[index].translations[0].description | safeHtml)
            "
        ></p>

        <app-flat-button
            class="slide-btn mr-12"
            [label]="relatedPostings[index].postingType.actionButtonTextKey"
            (onClick)="openPostingUrl()"
            *ngIf="relatedPostings[index].url"
        ></app-flat-button>
    </div>
</div>
